let instance = null;
import Accordion from "../components/Accordion";
import CampaignReports from "../components/CampaignReports";
import Modals from "../components/Modals";
import Forms from "../components/Forms";
import HtmlVideoPlayer from "../components/HtmlVideoPlayer";
import VimeoVideoPlayer from "../components/VimeoVideoPlayer";
import Nav from "../components/Nav";
import Observer from "../components/Observer";
import "../components/CookiesConsent";
import "../components/utilities";
import "../components/ModeToggle";
import "../components/NotificationToggle";
import "../components/People";
import "../components/LoadMore";
import "../components/NumberCounter";
import "../components/Ledging";

export default class App {
  constructor() {
    /**
     * Setup Commands
     */

    // make singleton
    if (instance) {
      return instance;
    }
    instance = this;

    // global access

    window.app = this;

    // get context

    this.getContext();

    window.addEventListener("resize", () => {
      this.getContext();
    });

    /**
     * Components
     */

    this.observer = new Observer();
    this.nav = new Nav();
    this.accordion = new Accordion();
    this.campaignReports = new CampaignReports();
	this.modals = new Modals();
	this.forms = new Forms();

    this.htmlVideos = document.querySelectorAll('.video--html');
    this.htmlVideos && this.htmlVideos.forEach((video)=>
    {
        let options = 
        {
            autoplay: false,
            loop: true,
            muted: true,
            controls: true,
            progress: true,
        }
        
        new HtmlVideoPlayer(video, options);

    })

    this.vimeoVideos = document.querySelectorAll('.video--vimeo');
    this.vimeoVideos && this.vimeoVideos.forEach((video)=>
    {
        let options = 
        {
            autoplay: true,
            loop: true,
            muted: true,
            controls: true,
            progress: true,
        }
        let player = new VimeoVideoPlayer(video, options);
    })
  }
  getContext() {
    // Tells us if App is Mobile, and height of Viewport.

    if (window.matchMedia("(max-width: 1024px)").matches) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    if (window.location.host.includes("localhost")) {
      this.URL =
        "http://" +
        window.location.host +
        `/${REPO}/wp-content/themes/${THEME}`;
    } else {
      this.URL =
        "https://" + window.location.host + `/wp-content/themes/${THEME}`;
    }

    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${this.vh}px`);
  }
}